// Editorial page header used across every module: a small uppercase eyebrow, a
// large title, and an optional subtitle — plus an optional actions slot on the
// right (filters, buttons). Gives the whole dashboard a consistent, designed feel.
export const PageHeader = ({ eyebrow, title, subtitle, actions }) => (
  <div className="flex items-start justify-between gap-4 flex-wrap">
    <div className="min-w-0">
      {eyebrow && <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-600 mb-1.5">{eyebrow}</p>}
      <h1 className="text-2xl sm:text-[28px] leading-tight font-bold text-slate-900 tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1.5 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0 flex-wrap">{actions}</div>}
  </div>
);
